export class TableContextKind {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "value",
            "baseName": "value",
            "type": "string",
            "format": ""
        },
        {
            "name": "share",
            "baseName": "share",
            "type": "number",
            "format": ""
        },
        {
            "name": "sampledRows",
            "baseName": "sampledRows",
            "type": "number",
            "format": ""
        },
        {
            "name": "columns",
            "baseName": "columns",
            "type": "Array<TableContextKindColumn>",
            "format": ""
        },
        {
            "name": "note",
            "baseName": "note",
            "type": "string",
            "format": ""
        },
        {
            "name": "noteEdit",
            "baseName": "noteEdit",
            "type": "TableContextEdit",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return TableContextKind.attributeTypeMap;
    }
    constructor() {
    }
}
